export const DisplayModeIds = {
  Panel: 1,
  Popup: 2,
  Banner: 3,
} as const;
